import React, { useContext } from "react";
import AuthContext from "context/AuthContext";
import MapPoligonJS from "./MapPoligonJS";
import AzureMapPoligon from "./azure/AzureMapPoligon";

const MapPoligonManager = (props) => {
    const { panel } = useContext(AuthContext);
    const provider = props.provider || panel?.map_type || 'lf';
    switch (provider) {
        case 'az':
            return <AzureMapPoligon {...props} />;
        case 'lf':
        default:
            return <MapPoligonJS {...props} />;
    }
};

export default MapPoligonManager;
